/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Environment detection based on URL
 */
const isDevelopment = window.location.hostname.endsWith("-dev.checkurmed.com") | window.location.hostname.endsWith("localhost") | window.location.hostname.endsWith("127.0.0.1");

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: isDevelopment
      ? "b360f826-76c5-49cc-8958-ec7d1f004b57" // Development client ID
      : "3edbda54-eeef-4862-adb2-27dbbf910b29", // Production client ID
    authority:
      "https://login.microsoftonline.com/efba259f-e4b8-4473-86c8-9f8e89ae5831", // Defaults to "https://login.microsoftonline.com/common"
    redirectUri: "/", // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [],
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  graphMe: {
    endpoint: "https://graph.microsoft.com/v1.0/me",
    scopes: ["User.Read"],
  },
  apiHello: {
    endpoint: "http://localhost:5000/products",
    scopes: [
      isDevelopment
        ? "api://a82c698e-c6d2-4427-ab47-2544ae644aa9/Product.Read" // Development scope
        : "api://99a9df08-22fc-440c-afb4-91c3c785ca6c/Product.Read", // Production scope
    ],
  },
};
